import { Chips } from 'components/Chips/Chips'
import NavLink from 'components/NavLink/NavLink'
import { DefaultProps } from 'components/NavLink/types'
import { formatCappedCount } from 'helper/numbers'
import { useSelector } from 'react-redux'
import { getTotalUnreadMessages } from 'redux/store/chatSocket/getters'

export const ChatMenuItem = (
  props: Pick<DefaultProps, 'label' | 'hrefTo' | 'Icon'>
) => {
  const unreadNotifications = useSelector(getTotalUnreadMessages)

  return (
    <NavLink {...props} className="full-width row space-between">
      {!!unreadNotifications && (
        <Chips.Menu>{formatCappedCount(unreadNotifications)}</Chips.Menu>
      )}
    </NavLink>
  )
}
